const downloadCanvasAsImage = (
  canvas: HTMLCanvasElement,
  backgroundColor = '#eff0f5'
): string => {
  const destinationCanvas = document.createElement('canvas');
  destinationCanvas.width = canvas.width;
  destinationCanvas.height = canvas.height;

  const destCtx = destinationCanvas.getContext('2d');
  if (!destCtx) {
    return '';
  }

  if (backgroundColor) {
    destCtx.fillStyle = backgroundColor;
    destCtx.fillRect(0, 0, canvas.width, canvas.height);
  }
  destCtx.drawImage(canvas, 0, 0);
  destinationCanvas.toDataURL();
  const dataUrl = destinationCanvas.toDataURL('image/png');
  return dataUrl;
};
export default downloadCanvasAsImage;
